import type { App } from 'vue';
import type { Router } from 'vue-router';

import type { SoaConfig } from '@/core/lib/Config';
import ActualitesDomain from '@/domains/actualites';
import ClientsDomain from '@/domains/clients';
import ConditionsGeneralesDomain from '@/domains/conditionsGenerales';
import ContactsDomain from '@/domains/contacts';
import ContratDomain from '@/domains/contrats';
import AccueilFrontDomain from '@/domains/dashboard';
import DocumentationDomain from '@/domains/documentation';
import MentionsLegalesDomain from '@/domains/mentionsLegales';
import OffresDomain from '@/domains/offres';
import ProjetsDomain from '@/domains/projets';
import ReglementaireDomain from '@/domains/reglementaire';
import RemunerationsDomain from '@/domains/remunerations';
import UtilisateursDomain from '@/domains/utilisateurs';

interface RegisterDomainsOptions {
  app: App<Element>;
  router: Router;
  config: SoaConfig;
}

export function registerDomains({ app, router, config }: RegisterDomainsOptions): void {
  app.use(AccueilFrontDomain, { router, config });
  app.use(ActualitesDomain, { router, config });
  app.use(ClientsDomain, { router, config });
  app.use(ConditionsGeneralesDomain, { router, config });
  app.use(ContactsDomain, { router, config });
  app.use(ContratDomain, { router, config });
  app.use(DocumentationDomain, { router, config });
  app.use(MentionsLegalesDomain, { router, config });
  app.use(OffresDomain, { router, config });
  app.use(ProjetsDomain, { router, config });
  app.use(ReglementaireDomain, { router, config });
  app.use(RemunerationsDomain, { router, config });
  app.use(UtilisateursDomain, { router, config });
}
